const isArray = arr => {
	return arr && arr.constructor === Array;
};

const isObject = obj => {
	return obj && obj !== null && typeof obj === 'object';
};

const isObjectEmpty = obj => {
	return Object.keys(obj).length === 0;
};

export default {
	isArray () { return isArray },
	isObject () { return isObject },
	isObjectEmpty () { return isObjectEmpty }
};